import { createAction } from 'redux-actions'

export const setSelectedRetailerId = createAction(
  'DUPLICATE_ORDERS_MODAL/SET_SELECTED_RETAILER_ID',
)
export const changeRetailerSearchText = createAction(
  'DUPLICATE_ORDERS_MODAL/CHANGE_RETAILER_SEARCH_TEXT',
)
